document.addEventListener("DOMContentLoaded", function () {
	function wrapInVidFluid($element) {
		if ($element.closest(".vid-fluid").length === 0) {
			$element.wrap('<div class="vid-fluid"></div>');
		}
	}

	$(".vid-responsive").each(function () {
		wrapInVidFluid($(this));
	});

	$("iframe").filter(function () {
		const src = ((this.getAttribute("src") || this.getAttribute("data-src") || "")).toLowerCase();
		return src.includes("youtube") || src.includes("vimeo");
	}).each(function () {
		wrapInVidFluid($(this));
	});
});
